// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    line-height: 1.6;
}

.how-text {
    margin-bottom: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/assets/Documents/css/HowSkitterbookWorks.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.how-container {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    padding: 2rem;\r\n    line-height: 1.6;\r\n}\r\n\r\n.how-text {\r\n    margin-bottom: 1.25rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
